import _asyncToGenerator from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
export default {
  name: 'd2-tencent-captcha',
  methods: {
    onClick: function onClick() {
      var _this = this;

      var TencentCaptcha = window.TencentCaptcha;
      var captcha = new TencentCaptcha(this.$env.VUE_APP_TENCENT_CAPTCHA_APP_ID, /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(result) {
          var randstr, ticket;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(result.ret === 0)) {
                    _context.next = 10;
                    break;
                  }

                  randstr = result.randstr, ticket = result.ticket;
                  _context.prev = 2;
                  _context.next = 5;
                  return _this.$api.CAPTCHA_CHECK({
                    randstr: randstr,
                    ticket: ticket
                  });

                case 5:
                  _this.$emit('success');

                  _context.next = 10;
                  break;

                case 8:
                  _context.prev = 8;
                  _context.t0 = _context["catch"](2);

                case 10:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[2, 8]]);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }(), {});
      captcha.show();
    }
  }
};